export const StashOrPass = 'stashOrPass';
export const ExtraRip = 'extraRip';
export const FreeCredit = 'freeCredit';
export const LootBox = 'lootBox';

export const ResultStash = 'stash';
export const ResultPass = 'pass';
